<template>
  <div class="content">
    <el-dialog v-bind="$attrs" v-on="$listeners" @open="onOpen" title="新增">
      <el-row :gutter="15">
        <el-form
          ref="addRef"
          :model="roleInfo"
          :rules="rules"
          size="medium"
          label-width="100px"
        >
          <el-col :span="12">
            <el-form-item label="角色名称" prop="name">
              <el-input
                v-model="roleInfo.name"
                clearable
                :style="{ width: '100%' }"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="角色编码" prop="code">
              <el-input
                v-model="roleInfo.code"
                clearable
                :style="{ width: '100%' }"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="角色描述" prop="description">
              <el-input
                v-model="roleInfo.description"
                clearable
                :style="{ width: '100%' }"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属企业" prop="companyId">
              <el-input
                v-model="roleInfo.companyId"
                clearable
                :style="{ width: '100%' }"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
      <div slot="footer" v-if="true">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" @click="handelConfirm">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// import { add, addSubList } from "@/api/erModel/roleManagementEr";
// import { getAllSystem } from "@/api/dataModel/appSystem";

import { addRole,}  from '@/api/systemData'
export default {
  inheritAttrs: false,
  props: [""],
  data() {
    return {
      roleInfo: {
        name: "",
        code: "",
        description: "",
        companyId: "",
      },
      otherForm: {
        roleAppSystemRelForm: {
          id: "",
          idList: [],
        },
      },
      allAppList: [],
      rules: {
        name: [
          {
            required: true,
            message: "角色名称不能为空",
            trigger: "blur",
          },
        ],
        code: [
          {
            required: true,
            message: "角色编码不能为空",
            trigger: "blur",
          },
        ],
        description: [
          {
            required: false,
            message: "角色描述不能为空",
            trigger: "blur",
          },
        ],
        companyId: [
          {
            required: true,
            message: "角色所属企业不能为空",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {},
  watch: {},
  created() {
    // this.getAppSystemNameOptions();
  },
  mounted() {},
  methods: {
    onOpen() {},
    onClose() {
      this.$refs["addRef"].resetFields();
    },
    close() {
      this.$emit("update:visible", false);
    },
    handelConfirm() {
      this.$refs["addRef"].validate((valid) => {
        if (valid) {
          addRole(this.roleInfo).then((res) => {
            if (res.code == 10000) {
              this.$emit("add-success");
            }
          });
          this.close();
        }
      });
    },
    getAppSystemNameOptions() {
      // 注意：this.$axios是通过Vue.prototype.$axios = axios挂载产生的
      this.$axios({
        method: "get",
        url: "/api/yys/appSystem/getAll",
      }).then((resp) => {
        let { data } = resp;
        let list = data.data;
        const newOptions = list.map((item) => {
          return {
            value: item["id"],
            label: item["appSystemName"],
          };
        });
        this.appSystemNameOptions = newOptions;
        // this.appSystemNameOptions = data.undefined
      });
    },
  },
};
</script>
<style>
.content {
  background-color: #fff;
  padding: 10px;
}
</style>
